import React from 'react';

import cs from 'classnames';

import {CopyTextButton} from 'app/components/general/CopyLinkButton';
import {gt} from 'app/utils/i18n';

interface Props {
  id: string;
  disabled: boolean;
  label: string | React.ReactNode | ((text: string) => React.ReactNode);
  value: string;
  className?: string;
  children?: React.ReactNode;
}

export function CopyClipboardInputField({
  id,
  disabled,
  label,
  value,
  className,
  children,
}: Props): JSX.Element {
  const inputId = `copiable-input-${id}`;

  return (
    <div className={cs('form-group', className)}>
      {typeof label === 'function' ? (
        label(inputId)
      ) : (
        <label htmlFor={inputId}>{label}</label>
      )}
      <div className="input-group">
        <input
          className="form-control"
          type="text"
          disabled={disabled}
          id={inputId}
          readOnly
          value={value}
          onClick={(event) => event.stopPropagation()}
        />
        <div className="input-group-append">
          <CopyTextButton
            tooltip={gt('Click to copy')}
            className="btn btn-secondary"
            disabled={disabled}
            text={value}
          >
            <i className="far fa-cut" />
          </CopyTextButton>
        </div>
      </div>
      {children}
    </div>
  );
}
